import { render, staticRenderFns } from "./CompletionRate.vue?vue&type=template&id=7157444e&scoped=true&"
import script from "./CompletionRate.vue?vue&type=script&lang=js&"
export * from "./CompletionRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7157444e",
  null
  
)

export default component.exports